module.exports = __webpack_public_path__ + "static/media/webdevelopment.45f9b36e.jpg";